import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { WORKFLOW_QUERY } from '../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import './Custom.css'
import { getData } from './CustomUtils.js'

const WORKFLOW = gql(WORKFLOW_QUERY)

export default function Workflow({ location }) {
  console.log('Workflow rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const params = new URLSearchParams(location.search)
  const objectTypeId = params.get('in_document_type')

  useEffect(() => {
    getData(null, WORKFLOW, 'workflow', setResults, setGraphQLErrors, 'objectTypeId', objectTypeId)
  }, [objectTypeId])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <div dangerouslySetInnerHTML={{ __html: results }}  className="bordered-table" />
      </div>
    )
  }
}
